import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import RestaurantsApi from 'libs/api/restaurants';

import Modal from 'components/molecules/Modal';
import Breadcrumbs from 'components/molecules/Breadcrumbs';
import Button from 'components/atoms/Button';
import { useUser } from 'redux/user/use-user';
import RouterHelper from 'services/RouterHelper';
import { useCommon } from 'redux/common/use-common';
import ModalConfigContent from 'components/molecules/ModalContents/Config';
import { useCompany } from 'redux/company/use-company';

import {
  SubTitle,
  Wrapper,
  Content,
  LogoutWrapper,
  ConfigButton,
} from './styled';
import DataHelper from '../../../services/DataHelper';
import AuthService from '../../../services/Auth';
import routeCodes from '../../../common/constants/route-codes';
import { useRestaurant } from '../../../redux/restaurant/use-restaurant';

const api = new RestaurantsApi();

const PageTitle = ({
  forceTitle,
  forceHideHideButton = false,
  forceRightComponent,
}) => {
  const [modalParams, setModalParams] = useState({
    show: false,
  });
  const { isSuperAdmin, userData } = useUser();
  const history = useHistory();
  const location = useLocation();
  const [restaurants, setRestaurants] = useState([]);
  const [inProcess, setInProcess] = useState(false);
  const { handleLogout } = useUser();
  const {
    currentRestaurant,
    handleSetCurrentRestaurant,
    resetState,
  } = useCommon();
  const { pathname } = useLocation();
  const { listData: companies } = useCompany();
  const { listData } = useRestaurant();
  const items = RouterHelper.getBreadcrumbItems(
    pathname,
    isSuperAdmin ? 'Super admin' : 'Home',
    isSuperAdmin,
  );

  const [selectedValues, setSelectedValues] = useState({
    company: '',
    restaurant: '',
  });

  const showLogout =
    !!pathname.includes('/profile') || !!pathname.includes('administration');

  const onClickConfig = useCallback(() => {
    setModalParams((s) => ({
      ...s,
      show: true,
    }));
  }, []);

  const onCloseModal = useCallback(() => {
    setModalParams((state) => ({
      ...state,
      show: false,
    }));
  }, []);

  const onSelectRestaurant = useCallback(async (e) => {
    const {
      target: { name, value },
    } = e;
    if (name === 'company') {
      try {
        // const {
        //   data: { company },
        // } = await companiesApi.get(value);
        const api = new RestaurantsApi();
        const { data } = await api.list({
          params: {
            per: 1000,
            company_id: value,
          },
        });
        setSelectedValues((s) => ({
          ...s,
          [name]: parseInt(value),
          restaurant: '',
        }));
        setRestaurants(data?.restaurants);
      } catch (e) {}
    } else {
      setSelectedValues((s) => ({
        ...s,
        [name]: parseInt(value),
      }));
    }
  }, []);

  const onSubmit = useCallback(async () => {
    setInProcess(true);
    try {
      const {
        data: { restaurant },
      } = await api.get(selectedValues.restaurant);
      setModalParams((s) => ({
        ...s,
        show: false,
      }));
      AuthService.setCurrentRestaurant(restaurant?.id);
      const {
        route: needToRedirect,
        forceRefresh,
      } = DataHelper.getRoutAfterChangeRestaurant(location.pathname);
      if (forceRefresh) {
        return window.location.reload();
      } else {
        resetState();
      }
      history.push(needToRedirect);
      handleSetCurrentRestaurant(restaurant);
    } catch (e) {
      console.log('Fetch current restaurant error', e);
    } finally {
      setInProcess(false);
    }
  }, [selectedValues, history, location, resetState]);

  const onClickBackToList = useCallback(() => {
    history.push(
      routeCodes.restaurantsView.replace(':restaurantId', currentRestaurant.id),
    );
  }, [history, currentRestaurant]);
  const showHidList = pathname.includes('restaurants');
  const showChooseRestaurant = listData?.items && listData?.items?.length > 1;
  return (
    <Wrapper>
      <Breadcrumbs items={items} />
      <Content showLogout={showLogout}>
        <SubTitle>
          {forceTitle || currentRestaurant?.title}
          {!showLogout && !isSuperAdmin && showChooseRestaurant && (
            <ConfigButton onClick={onClickConfig}>Cambia</ConfigButton>
          )}
        </SubTitle>
        {showLogout && (
          <LogoutWrapper>
            <Button width='155px' onClick={handleLogout}>
              Log out
            </Button>
          </LogoutWrapper>
        )}
        {!showLogout &&
          currentRestaurant?.id &&
          !forceHideHideButton &&
          showHidList &&
          isSuperAdmin && (
            <LogoutWrapper>
              <Button
                width='155px'
                color='primary_light'
                onClick={onClickBackToList}
              >
                Torna all’elenco
              </Button>
            </LogoutWrapper>
          )}
        {!!forceRightComponent && (
          <LogoutWrapper>{forceRightComponent}</LogoutWrapper>
        )}
      </Content>
      <Modal
        desktopMinH='30vh'
        inProcess={inProcess}
        open={modalParams.show}
        onClose={onCloseModal}
        cancelButtonText='Indietro'
        title='Cambia società e attività'
        body={
          <ModalConfigContent
            restaurants={restaurants}
            // companies={companies?.items}
            companies={userData?.available_companies}
            onSelect={onSelectRestaurant}
            selectedCompany={selectedValues.company}
            selectedRestaurant={
              // TODO improve
              // selectedValues.restaurant || currentRestaurant?.id || 'DEFAULT'
              selectedValues.restaurant
            }
          />
        }
        onCancel={onCloseModal}
        onSubmit={onSubmit}
        variant='config'
        disabled={
          !(
            selectedValues?.restaurant &&
            selectedValues?.company &&
            selectedValues?.restaurant !== currentRestaurant?.id
          )
        }
      />
    </Wrapper>
  );
};

PageTitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default PageTitle;
